const FORM_SELECTOR = "[data-login-form]";
const SUBMIT_BUTTON_SELECTOR = "[data-login-submit-button]";
const SUBMIT_SPINNER_SELECTOR = "[data-login-submit-spinner]";
const SUBMIT_LABEL_SELECTOR = "[data-login-submit-label]";
const INITIALIZED_FLAG = "loginSubmitLockBound";
const SUBMITTING_FLAG = "loginSubmitting";

function collectForms(root) {
  const forms = [];

  if (root instanceof HTMLFormElement && root.matches(FORM_SELECTOR)) {
    forms.push(root);
  }

  if (root instanceof Document || root instanceof Element) {
    forms.push(...root.querySelectorAll(FORM_SELECTOR));
  }

  return Array.from(new Set(forms));
}

function setSubmittingState(form, isSubmitting) {
  form.dataset[SUBMITTING_FLAG] = isSubmitting ? "1" : "0";

  const submitButton = form.querySelector(SUBMIT_BUTTON_SELECTOR);
  const submitSpinner = form.querySelector(SUBMIT_SPINNER_SELECTOR);
  const submitLabel = form.querySelector(SUBMIT_LABEL_SELECTOR);

  if (submitButton instanceof HTMLButtonElement) {
    submitButton.disabled = isSubmitting;
    submitButton.setAttribute("aria-busy", isSubmitting ? "true" : "false");
  }

  if (submitSpinner instanceof Element) {
    submitSpinner.classList.toggle("d-none", !isSubmitting);
  }

  if (submitLabel instanceof Element) {
    submitLabel.textContent = isSubmitting ? "Trwa logowanie..." : "Zaloguj";
  }
}

export function initLoginSubmitLock(root = document) {
  const forms = collectForms(root);

  forms.forEach((form) => {
    if (form.dataset[INITIALIZED_FLAG] === "1") {
      return;
    }

    form.dataset[INITIALIZED_FLAG] = "1";
    setSubmittingState(form, false);

    form.addEventListener("submit", (event) => {
      if (form.dataset[SUBMITTING_FLAG] === "1") {
        event.preventDefault();
        return;
      }

      setSubmittingState(form, true);
    });
  });

  return forms.length > 0;
}

window.addEventListener("pageshow", (event) => {
  if (!event.persisted) {
    return;
  }

  collectForms(document).forEach((form) => setSubmittingState(form, false));
});